
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Delhincr() {



  const cardData =
  {
    keyword: 'Patient Forced Air Warming Blankets in Delhi NCR',
    heading: 'Pharmacle Health Care Private Limited: Patient Forced Air Warming Blankets in Delhi NCR',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Forced Air Warming Blankets in Delhi NCR, ensuring effective temperature management for patients during surgeries and critical care. Our Wallabies Warm Care blankets are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our forced air warming blankets are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Delhi NCR to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


    "topPlaces": [
  {
    "title": "Advanced Patient Forced Air Warming Blankets in Delhi NCR",
    "description": "Pharmacle Health Care Private Limited supplies advanced patient forced air warming blankets in Delhi NCR, designed to maintain body temperature and prevent perioperative hypothermia across surgical, ICU, and recovery care."
  },
  {
    "title": "Surgical Forced Air Warming Blankets in Delhi NCR",
    "description": "Pharmacle Health Care Private Limited provides surgical warming blankets in Delhi NCR, engineered for operating rooms to ensure uniform heat distribution and improved patient safety during procedures."
  },
  {
    "title": "Preoperative & Postoperative Warming Blankets in Delhi NCR",
    "description": "Our pre- and postoperative forced air warming blankets in Delhi NCR enhance patient comfort, stabilize core temperature, and support faster recovery after surgery."
  },
  {
    "title": "ICU Forced Air Warming Blankets in Delhi NCR",
    "description": "Pharmacle Health Care Private Limited offers ICU-grade warming blankets in Delhi NCR, providing controlled thermal support for critically ill patients in intensive care settings."
  },
  {
    "title": "Neonatal Forced Air Warming Blankets in Delhi NCR",
    "description": "Specially designed for NICUs and maternity wards, our neonatal warming blankets in Delhi NCR provide gentle and precise temperature control for premature and low-birth-weight infants."
  },
  {
    "title": "Emergency Forced Air Warming Blankets in Delhi NCR",
    "description": "Pharmacle Health Care Private Limited delivers emergency-ready warming blankets in Delhi NCR, essential for trauma care to rapidly stabilize patient body temperature during critical interventions."
  },
  {
    "title": "Portable Patient Warming Blankets in Delhi NCR",
    "description": "Lightweight and efficient, our portable patient warming blankets in Delhi NCR are perfect for ambulances, field hospitals, and mobile medical units requiring quick warming solutions."
  },
  {
    "title": "Veterinary Forced Air Warming Blankets in Delhi NCR",
    "description": "Pharmacle Health Care Private Limited also supports veterinary clinics in Delhi NCR with warming blankets designed for pets and livestock, ensuring safe and effective thermal regulation during treatments."
  },
  {
    "title": "Disposable Forced Air Warming Blankets in Delhi NCR",
    "description": "Our single-use disposable warming blankets in Delhi NCR provide infection-free, hygienic patient care. Pharmacle Health Care Private Limited ensures hospitals and clinics get safe, contamination-free thermal support."
  },
  {
    "title": "Hospital-Grade Patient Warming Blankets in Delhi NCR",
    "description": "Pharmacle Health Care Private Limited manufactures hospital-grade patient warming blankets in Delhi NCR, offering consistent, high-performance thermal support for surgical theaters, ICUs, and recovery units."
  }
],

"services": [
    {
        "name": "Patient Forced Air Warming System Hyderabad",
        "description": "Pharmacle Health Care Private Limited offers patient forced air warming systems in Hyderabad, designed to regulate body temperature during surgeries, recovery, and critical care. These systems help prevent hypothermia by circulating warm air, ensuring patient comfort and safety."
    },
    {
        "name": "Hyderabad Patient Warming Equipment",
        "description": "We provide patient warming equipment in Hyderabad that is essential for maintaining a stable body temperature during medical treatments. These devices are specifically designed for use in surgeries, recovery, and critical care to ensure the patient’s safety and comfort."
    },
    {
        "name": "Forced Air Warming System Supplier Hyderabad",
        "description": "As a leading supplier of forced air warming systems in Hyderabad, Pharmacle Health Care provides reliable and effective solutions for maintaining patient body temperature during surgeries and critical care. Our systems are designed to enhance patient safety and prevent hypothermia."
    },
    {
        "name": "Hyderabad Patient Thermoregulation Systems",
        "description": "We offer patient thermoregulation systems in Hyderabad that help manage and stabilize body temperature during medical procedures. These systems are vital for ensuring safe and comfortable conditions during surgeries and post-operative care."
    },
    {
        "name": "Hyderabad Medical Warming Devices",
        "description": "Pharmacle Health Care supplies medical warming devices in Hyderabad, designed to regulate body temperature during surgeries, recovery, and critical care. These devices prevent hypothermia and ensure optimal comfort and safety for patients during their medical treatment."
    },
    {
        "name": "Hyderabad Patient Body Temperature Control Solutions",
        "description": "Our patient body temperature control solutions in Hyderabad are designed to provide effective thermoregulation during medical treatments. These solutions ensure that patients are kept at a safe and comfortable body temperature, preventing hypothermia and improving overall care outcomes."
    }
],
"tableData": [
    ["- Patient Forced Air Warming System Hyderabad", "- Hyderabad Patient Warming Equipment"],
    ["- Forced Air Warming System Supplier Hyderabad", "- Hyderabad Patient Thermoregulation Systems"],
    ["- Hyderabad Medical Warming Devices", "- Hyderabad Patient Body Temperature Control Solutions"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient forced air warming blankets in Delhi NCR, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across the Delhi NCR region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient forced air warming blankets in Delhi NCR, including warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient forced air warming blankets are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our blankets provide optimal reliability for continuous use in medical settings throughout Delhi NCR."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our forced air warming blankets provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Delhi NCR are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient forced air warming blankets in Delhi NCR are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient forced air warming blankets are designed for seamless integration with existing medical systems in Delhi NCR. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Delhi NCR to help healthcare facilities select the right patient forced air warming blankets for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient forced air warming blankets are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Delhi NCR receives the highest standard of care."
    }
]












  }

  const faqData = [
    { question: "What is a Patient Forced Air Warming Blanket?", answer: "A Patient Forced Air Warming Blanket is a medical device used to maintain a patient’s body temperature by circulating warm air through a special blanket, preventing hypothermia during surgeries or medical procedures." },
    { question: "How does the Patient Forced Air Warming Blanket work?", answer: "The blanket uses warm air circulated through it by a blower. The warm air helps regulate the patient’s body temperature, ensuring they stay warm and comfortable during medical procedures." },
    { question: "Is the Patient Forced Air Warming Blanket available in Delhi NCR?", answer: "Yes, Pharmacle Health Care Private Limited offers Patient Forced Air Warming Blankets in Delhi NCR, providing healthcare facilities with an effective solution for regulating patient body temperature during medical treatments." },
    { question: "What are the benefits of using a Patient Forced Air Warming Blanket?", answer: "The main benefits include preventing hypothermia, reducing surgical complications, improving patient comfort, and maintaining a stable body temperature during medical procedures." },
    { question: "How long can the Patient Forced Air Warming Blanket maintain the patient’s temperature?", answer: "The blanket can maintain the patient’s body temperature for the duration of the medical procedure, ensuring consistent warmth and preventing any fluctuations in body temperature." },
    { question: "Is the Patient Forced Air Warming Blanket easy to use?", answer: "Yes, the Patient Forced Air Warming Blanket is designed to be user-friendly, with simple controls for healthcare professionals to adjust temperature settings during medical procedures." },
    { question: "Can the Patient Forced Air Warming Blanket be used for all types of surgeries?", answer: "Yes, the blanket is suitable for use in a wide range of surgeries and medical procedures, especially those where temperature regulation is crucial for patient safety." },
    { question: "Is the Patient Forced Air Warming Blanket safe for all patients?", answer: "Yes, the blanket is safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and avoid any risk of overheating." },
    { question: "How can I purchase a Patient Forced Air Warming Blanket in Delhi NCR?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Patient Forced Air Warming Blanket to healthcare facilities in Delhi NCR." },
    { question: "Does Pharmacle Health Care provide support for Patient Forced Air Warming Blankets?", answer: "Yes, we offer full support for Patient Forced Air Warming Blankets, including installation, training for healthcare professionals, and ongoing maintenance to ensure the system works effectively." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Forced Air Warming Blanket from Pharmacle Health Care in our Delhi NCR hospital, and it has helped ensure our patients stay warm and safe during surgeries, reducing the risk of complications.',
      name: 'Dr. Rajeev Kumar',
    },
    {
      text: 'The Patient Forced Air Warming Blanket from Pharmacle Health Care has been a valuable addition to our clinic in Delhi NCR. It’s easy to use, reliable, and ensures our patients maintain optimal body temperature during treatments.',
      name: 'Dr. Aarti Mehra',
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];

  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Forced Air Warming Blankets in Delhi NCR",
    "description": "Discover high-quality Patient Forced Air Warming Blankets in Delhi NCR for effective patient temperature regulation during medical treatments and surgeries. Our blankets provide optimal comfort and safety in hospital settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "2145"
    }
  };
  

  




  return (
    <div>

<Helmet>
    <title>Patient Forced Air Warming Blankets in Delhi NCR | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore Patient Forced Air Warming Blankets in Delhi NCR for effective temperature regulation and patient thermoregulation during medical treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Forced Air Warming Blankets Delhi NCR, Delhi NCR Medical Warming Blankets, Warming Blankets Delhi NCR, Patient Warming Systems Delhi NCR, Delhi NCR Temperature Management Blankets, Surgical Warming Blankets Delhi NCR"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/15.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Delhincr;